import {
  GALLERY_IMPRESSION_TRACKING_ZONE,
  GALLERY_TRACKING_ZONE,
} from '~/scopes/product-core/components/presentationals/ProductDetailPageGallery/composables/useGalleryTracking/useGalleryTracking.constants'

export type GalleryItemKind = 'image' | 'video' | 'review' | 'skeleton'

function mapItemKindToImageType(kind: GalleryItemKind): string {
  if (kind === 'review') return 'review_image'
  if (kind === 'video') return 'vr_video'

  return 'product_image'
}

export function buildScrollStartTrackingPayload(trackingProductModel: string) {
  return {
    name: 'scroll_start',
    zone: GALLERY_TRACKING_ZONE,
    product_model: trackingProductModel,
  }
}

export function buildScrollEndTrackingPayload(trackingProductModel: string) {
  return {
    name: 'scroll_end',
    zone: GALLERY_TRACKING_ZONE,
    product_model: trackingProductModel,
  }
}

export function buildSlideImpressionTrackingPayload({
  currentSlide,
  totalSlides,
  itemKind,
}: {
  currentSlide: number
  totalSlides: number
  itemKind: GalleryItemKind
}) {
  return {
    name: 'product',
    zone: GALLERY_IMPRESSION_TRACKING_ZONE,
    currentSlide,
    value: `${currentSlide + 1}/${totalSlides}`,
    imageType: mapItemKindToImageType(itemKind),
  }
}

export function buildVideoPlayTrackingPayload(trackingProductModel: string) {
  return {
    name: 'video_play',
    zone: GALLERY_TRACKING_ZONE,
    product_model: trackingProductModel,
  }
}

export function buildVideoCompleteTrackingPayload(
  trackingProductModel: string,
) {
  return {
    name: 'video_completed',
    zone: GALLERY_TRACKING_ZONE,
    product_model: trackingProductModel,
  }
}

export function buildReviewClickTrackingPayload({
  averageRate,
  count,
}: {
  averageRate: number
  count: number
}) {
  return {
    name: 'go_to_reviews',
    page_type: 'product',
    value: {
      average_rate: averageRate,
      count,
    },
    zone: 'image_carousel',
  }
}
